import { Search } from "lucide-react";

export function AddMealToPlanModalSearchBar({ searchQuery, setSearchQuery }) {
  return (
    // Inside AddMealToPlanModalSearchBar.tsx
    <div className="px-6 py-4 border-b border-gray-200 flex-1">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search recipes..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          autoFocus={false}
        />
      </div>
    </div>
  );
}
